import React, { CSSProperties, ReactElement } from 'react';
import AntdRow from 'antd/lib/grid/row';
import AntdCol from 'antd/lib/grid/col';
import { reactNodeIsOfType } from '../../utils';

export declare type Breakpoint = 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'xs';
export declare type Gutter = number | Partial<Record<Breakpoint, number>>;

export interface RowProps {
   align?: 'top' | 'middle' | 'bottom';
   gutter?: Gutter | [Gutter, Gutter];
   justify?: 'start' | 'end' | 'center' | 'space-around' | 'space-between';
   wrap?: boolean;
   className?: string;
   style?: CSSProperties;
}

export const Row = (props: React.PropsWithChildren<RowProps>) => {
   return (
      <AntdRow
         align={props.align}
         gutter={props.gutter}
         justify={props.justify}
         wrap={props.wrap}
         className={props.className}
         style={props.style}
      >
         {
            React.Children.map(props.children, child => {
               if (reactNodeIsOfType(child, Col)) {
                  const childElement = child as ReactElement;
                  const colProps = childElement.props as React.PropsWithChildren<ColProps>;

                  return (
                     <AntdCol
                        flex={colProps.flex}
                        offset={colProps.offset}
                        order={colProps.order}
                        pull={colProps.pull}
                        push={colProps.push}
                        span={colProps.span}
                        xs={colProps.xs}
                        sm={colProps.sm}
                        md={colProps.md}
                        lg={colProps.lg}
                        xl={colProps.xl}
                        xxl={colProps.xxl}
                     >
                        {colProps.children}
                     </AntdCol>
                  );
               }

               return undefined;
            })}
      </AntdRow>
   );
};

export declare type ColSpanType = number | string;
export declare type FlexType = number | 'none' | 'auto' | string;

export interface ColSize {
   flex?: FlexType;
   span?: ColSpanType;
   order?: ColSpanType;
   offset?: ColSpanType;
   push?: ColSpanType;
   pull?: ColSpanType;
}

export interface ColProps {
   flex?: FlexType;
   offset?: ColSpanType;
   order?: ColSpanType;
   pull?: ColSpanType;
   push?: ColSpanType;
   span?: ColSpanType;
   xs?: ColSpanType | ColSize;
   sm?: ColSpanType | ColSize;
   md?: ColSpanType | ColSize;
   lg?: ColSpanType | ColSize;
   xl?: ColSpanType | ColSize;
   xxl?: ColSpanType | ColSize;
   className?: string;
   style?: CSSProperties;
}

export class Col extends React.Component<ColProps> {
}
